import { workspaceDeveloperQueryKeys as e } from "./useWorkspaceDeveloperQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { workspaceDeveloperApi as n } from "@maat/api-main";
//#region src/workspaceDeveloper/useWorkspaceDeveloperDeliveryLogQuery.ts
var r = 50, i = (i, a = !0) => t({
	queryKey: e.deliveryLog(i),
	fetchPage: (e) => n.deliveries({
		...i,
		page: e,
		pageSize: r
	}),
	key: "items",
	enabled: a
});
//#endregion
export { i as useWorkspaceDeveloperDeliveryLogQuery };
